import { render } from "./store-loader-mobile.vue?vue&type=template&id=69269df4"
const script = {}

import exportComponent from "/Users/nikhiltongya/Desktop/Anatta Projects/stio-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__